// extracted by mini-css-extract-plugin
module.exports = {"loader":"SearchFilterLoader_loader__eTwuC"};